import React, { FunctionComponent } from 'react';
// import styles from "./Play.module.scss";
import playButton from "../../../images/playButton.svg";
import pauseButton from "../../../images/pauseButton.svg";
import { isEs } from "../../../libs/lang";


/**
 * Primary UI component for user interaction
 */
const Play = ({ariaPressed, toggle = false, alt, onClick, tabIndex}) => {

	const ariaAltPlay = () => isEs() ? "Botón de reproducir" : "Play Button";
	const ariaAltPause = () => isEs() ? "Pausa" : "Pause Button"


	let toggleImage = toggle ? <img src={pauseButton} /> : <img src={playButton} />;


	return (
		<div
			aria-pressed={ariaPressed}
			role="button"
			className={'playButton'}
			tabIndex={tabIndex}
			aria-label={`${ariaPressed ? ariaAltPause() : ariaAltPlay()}`}
			onClick={(e) => onClick(e)}
			style={{}}
			onKeyDown={(e) => onClick(e)}
		>
			{toggleImage}
		</div>
	);
};

export default Play;
